/* global globalThis */
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { Route, Routes } from "react-router-dom";
import { ROUTES } from "./constants/Route.js";
import APIService from "./Api/api.service.js";
import "./App.css";
import config from "./config.js";
import { ThemeContext } from "./context/themeContext.js";
import BulkRequest from "./pages/Bulkrequest.js";
import PartyRequest from "./pages/Partyrequest.js";
import Patient from "./pages/Patient.js";
import PatientDetails from "./pages/Patientdetails.js";
import PatientdetailsFMLA from "./pages/PatientdetailsFMLA.js";
import ProviderPortal from "./pages/ProviderPortal.js";
import Requirement from "./pages/Requirement.js";
import SingleRequest from "./pages/Singlerequest.js";
import TestClient from "./pages/TestClient.js";
import Thanks from "./pages/Thanks.js";
import Welcome from "./pages/Welcome.js";
import FeedBack from "./pages/FeedBack.js";
import FeedbackThanks from "./pages/FeedbackThanks.js";
import DocumentDownload from "./pages/DocumentDownload.js";
import DocumentLinkError from "./pages/DocumentLinkError.js";

const UnauthorizedScreen = () => (
  <div>
    <p>Unauthorized: Access is denied.</p>
  </div>
)

const LoadingScreen = () => (
  <div className="w-full min-h-screen border items-center justify-center self-center flex flex-col gap-2" >
    <Spin indicator={<LoadingOutlined fill={"#737373"} style={{ fontSize: 48, color: "#737373" }} spin />} />
  </div>
)

function App() {
  const [acessFlag, setacessFlag] = useState("loading");
  const [apiservice] = useState(() => new APIService());
  const { setTheme } = useContext(ThemeContext);
  const { t, i18n } = useTranslation();
  const isDocumentRoute = globalThis.location.pathname === ROUTES.DOCUMENT || globalThis.location.pathname === ROUTES.DOCUMENT_ERROR;

  // Sync signature watermark label for CSS pseudo-element with current language
  useEffect(() => {
    const label = t("common:signature_watermark");
    document.documentElement.style.setProperty("--signature-watermark-label", `"${label}"`);
  }, [i18n.language, t]);

  const setsecrateKey = (async (siteURL) => {
    const formData = new FormData();
    formData.append("siteURL", siteURL);
    let secrateKey = await apiservice.axiosPostRequest("SavePatientDetails/GetsecrateKey", formData)

    if (secrateKey != undefined && secrateKey != null) {
      if (secrateKey != "Failed") {
        sessionStorage.setItem("secrateKey", secrateKey);
        setacessFlag("authorized");
      }
      else { setacessFlag("unauthorized"); }
    }
    else {
      setacessFlag("unauthorized");
    }
  });

  const decryptData = (async (token) => {
    const formData = new FormData();
    formData.append("tokenKey", token);
    let ClientDetails = await apiservice.axiosPostRequest("SavePatientDetails/GetClientNameByToken", formData)
    //let data = await apiservice.axiosPostRequest("SavePatientDetails/GetDecryptedKey", formData)

    if (ClientDetails == "Failed") {
      sessionStorage.removeItem("secrateKey");
      setacessFlag("unauthorized")
    } else {
      if (ClientDetails != "undefined" && ClientDetails != null) {
        let ClientName = ClientDetails.clientName;
        if (ClientName != "undefined" && ClientName != null) {
          setsecrateKey(ClientName);
          sessionStorage.setItem("IsFMLAEnabled", ClientDetails.isFMLAEnabled);
          sessionStorage.setItem("currentActiveClient", ClientName);
          if (ClientName == "Trivalley Orthopedics") {
            setTheme("secondary");
          }
          else {
            setTheme("primary");
          }
        }
        else {
          sessionStorage.removeItem("secrateKey");
          setacessFlag("unauthorized")
        }
      }
      else {
        sessionStorage.removeItem("secrateKey");
        setacessFlag("unauthorized")
      }
    }
  });

  useEffect(() => {
    if (isDocumentRoute) {
      return;
    }

    const queryString = globalThis.location.search;
    //const urlParams = new URLSearchParams(queryString);
    let token = queryString.substring(1);//urlParams.get('token');
    let secrateKeyCheck = sessionStorage.getItem("secrateKey");
    if (token != "") {
      decryptData(token);
    }
    else if (secrateKeyCheck != "Failed" && secrateKeyCheck != undefined && secrateKeyCheck != null) {
      if (sessionStorage.getItem("currentActiveClient") == "Trivalley Orthopedics") {
        setTheme("secondary");
      }
      else {
        setTheme("primary");
      }
      setacessFlag("authorized");
    }
    else { setacessFlag("unauthorized"); }
  }, [isDocumentRoute, setTheme]);



  if (isDocumentRoute) {
    return (
      <Routes>
        <Route path={ROUTES.DOCUMENT} element={<DocumentDownload />}></Route>
        <Route path={ROUTES.DOCUMENT_ERROR} element={<DocumentLinkError />}></Route>
      </Routes>
    );
  }

  if (acessFlag === "authorized") {
    return (
    
        <Routes>
          <Route path={ROUTES.HOME_DEFAULT} element={sessionStorage.getItem("currentActiveClient") == "Trivalley Orthopedics" ? <Welcome /> : <ProviderPortal />}></Route>
          <Route path={ROUTES.WELCOME} element={<Welcome />}></Route>
          <Route path={ROUTES.PATIENT} element={<Patient />}></Route>
          <Route path={ROUTES.PATIENT_DETAILS} element={<PatientDetails />}></Route>
          <Route path={ROUTES.PARTY_REQUEST} element={<PartyRequest />}></Route>
          <Route path={ROUTES.SINGLE_REQUEST} element={<SingleRequest />}></Route>
          <Route path={ROUTES.BULK_REQUEST} element={<BulkRequest />}></Route>
          <Route path={ROUTES.THANKS} element={<Thanks />}></Route>
          {/* FMLA ROUTES */}
          <Route path={ROUTES.REQUIREMENT} element={<Requirement />}></Route>
          <Route path={ROUTES.PATIENT_DETAILS_FMLA} element={<PatientdetailsFMLA />}></Route>
          {/* Test Client */}
          <Route path={ROUTES.TEST_CLIENT} element={config.environment == "PROD" ? <Welcome /> : <TestClient />}></Route>
          {/* Feedback */}
          <Route path={ROUTES.FEEDBACK} element={<FeedBack />}></Route>
          <Route path={ROUTES.FEEDBACK_THANKS} element={<FeedbackThanks />}></Route>
        </Routes>
    );
  }
  else if (acessFlag === "unauthorized") {
    return (
      <Routes>
        <Route path={ROUTES.HOME_DEFAULT} element={<UnauthorizedScreen />}></Route>
        <Route path={ROUTES.TEST_CLIENT} element={config.environment == "PROD" ? <UnauthorizedScreen /> : <TestClient />}></Route>
        {/* Feedback */}
        <Route path={ROUTES.FEEDBACK} element={<FeedBack />}></Route>
        <Route path={ROUTES.FEEDBACK_THANKS} element={<FeedbackThanks />}></Route>
      </Routes>
    )
  }
  else {
    return (
      <Routes>
        <Route path={ROUTES.HOME_DEFAULT} element={<LoadingScreen />}></Route>
        <Route path={ROUTES.TEST_CLIENT} element={config.environment == "PROD" ? <LoadingScreen /> : <TestClient />}></Route>
        <Route path={ROUTES.FEEDBACK} element={<FeedBack />}></Route>
        <Route path={ROUTES.FEEDBACK_THANKS} element={<FeedbackThanks />}></Route>
      </Routes>
    )
  }
}
export default App;
